import React, {PureComponent} from 'react';
import {AutoSizer, CellMeasurer, List, CellMeasurerCache} from 'react-virtualized';
import styled from 'styled-components';

import SideModal from '../../components/SideModal';

import ExampleFormCard from './ExampleFormCard';

class ExampleFormModal extends PureComponent {
  cache = new CellMeasurerCache({
    defaultHeight: 232,
    fixedWidth: true
  });

  render() {
    const {open, onClose, examples} = this.props;
    const flattenedExamples = examples.reduce((list, category) => {
      return [
        ...list,
        {type: 'CATEGORY_TITLE', ...category},
        ...(category.forms.map(example => ({type: 'EXAMPLE', category, ...example})))
      ]
    }, []);

    return (
      <SideModal
        open={open}
        onClose={onClose}
        title="Templates">
        <AutoSizer>
          {({width, height}) => (
            <List
              ref={node => this.list = node}
              height={height}
              width={width}
              style={{overflowX: 'hidden'}}
              rowCount={flattenedExamples.length}
              rowHeight={this.cache.rowHeight}
              deferredMeasurementCache={this.cache}
              overscanRowCount={0}
              rowRenderer={({index, key, parent, style}) => {
                const item = flattenedExamples[index];
                
                return (
                  <CellMeasurer cache={this.cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
                    <div style={style}>
                      {item.type === 'EXAMPLE' ? (
                        <CardContainer>
                          <ExampleFormCard category={item.category} file={item.file} form={item.form} />
                        </CardContainer>
                      ) : (
                        <CategoryHeader>{item.category}</CategoryHeader>
                      )}
                    </div>
                  </CellMeasurer>
                );
              }}
            />
          )}
        </AutoSizer>
      </SideModal>
    );
  }
}

const CategoryHeader = styled.h2`
  font-weight: 300;
  margin: 2rem 1.875rem 1.5rem 1.875rem;
`;

const CardContainer = styled.div`
  margin: 1.875rem;
  margin-top: 0;
`;

export default ExampleFormModal;